module.exports = __webpack_public_path__ + "img/roubo.3b382c43.png";